import { render } from "./lift.vue?vue&type=template&id=387bc221"
import script from "./lift.vue?vue&type=script&lang=js"
export * from "./lift.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/arair-kiosk-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__